export default "/images/header.svg?4dbf1c7072e459af6f06704f078f64ee";